import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/use_time',
    meta: { title: 'NFC打刻登録' },
    component: () =>
      import('@/components/pages/PagesRegistrationUsageTime.vue'),
  },
  {
    path: '/search',
    meta: { title: 'NFC打刻一覧' },
    component: () => import('@/components/pages/PagesSearchUsageTime.vue'),
  },
  {
    path: '/child/use_time',
    component: () => import('@/components/pages/PagesChildRegistrationUsageTime.vue'),
  },
  {
    path: '/child/search',
    component: () => import('@/components/pages/PagesChildSearchUsageTime.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const DEFAULT_TITLE = '-'

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE
  next()
})

export default router
